import React, { useMemo, useState, useRef, useCallback, useEffect } from 'react';
import XLSXStyle from 'xlsx-js-style';

const CONCURRENCY = 3;
const BATCH_DELAY_MS = 1500;
const MAX_RETRIES = 2;
const MONTH_NAMES = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

const KEYWORD_GROUPS = [
  {
    name: 'Marka & Genel',
    color: 'bg-purple-50 border-purple-200 text-purple-700',
    xlsxColor: 'EDE9FE',
    keywords: [
      'high5', 'high5 ayakkabı', 'high5 mağaza'
    ]
  },
  {
    name: 'On Running',
    color: 'bg-sky-50 border-sky-200 text-sky-700',
    xlsxColor: 'E0F2FE',
    keywords: [
      'on running', 'on cloud', 'on cloudmonster', 'on cloudstratus', 'on cloudflow',
      'on cloudsurfer', 'on running ayakkabı', 'on running türkiye', 'on türkiye', 'on koşu ayakkabısı',
      'on cloudrunner', 'on cloudswift', 'on roger', 'on cloudventure'
    ]
  },
  {
    name: 'Hoka',
    color: 'bg-orange-50 border-orange-200 text-orange-700',
    xlsxColor: 'FFF7ED',
    keywords: [
      'hoka', 'hoka one one', 'hoka clifton', 'hoka bondi', 'hoka speedgoat',
      'hoka mach', 'hoka arahi', 'hoka ayakkabı', 'hoka koşu', 'hoka türkiye',
      'hoka challenger', 'hoka rincon', 'hoka gaviota'
    ]
  },
  {
    name: 'Asics',
    color: 'bg-red-50 border-red-200 text-red-700',
    xlsxColor: 'FEF2F2',
    keywords: [
      'asics', 'asics gel kayano', 'asics nimbus', 'asics novablast', 'asics gt 2000',
      'asics koşu ayakkabısı', 'asics türkiye', 'asics gel cumulus', 'asics gel resolution',
      'asics magic speed', 'asics metaspeed'
    ]
  },
  {
    name: 'Salomon',
    color: 'bg-emerald-50 border-emerald-200 text-emerald-700',
    xlsxColor: 'ECFDF5',
    keywords: [
      'salomon', 'salomon speedcross', 'salomon sense ride',
      'salomon ayakkabı', 'salomon outdoor', 'salomon koşu', 'salomon x ultra',
      'salomon trail', 'salomon türkiye'
    ]
  },
  {
    name: 'Brooks',
    color: 'bg-blue-50 border-blue-200 text-blue-700',
    xlsxColor: 'EFF6FF',
    keywords: [
      'brooks', 'brooks ghost', 'brooks glycerin', 'brooks adrenaline', 'brooks hyperion',
      'brooks koşu ayakkabısı', 'brooks caldera', 'brooks cascadia', 'brooks levitate'
    ]
  },
  {
    name: 'Saucony - Skechers',
    color: 'bg-amber-50 border-amber-200 text-amber-700',
    xlsxColor: 'FFFBEB',
    keywords: [
      'saucony', 'saucony endorphin', 'saucony kinvara', 'saucony ride', 'saucony triumph',
      'saucony peregrine', 'skechers', 'skechers go run', 'skechers max cushioning',
      'skechers koşu', 'skechers spor ayakkabı'
    ]
  },
  {
    name: 'Nike',
    color: 'bg-slate-50 border-slate-200 text-slate-700',
    xlsxColor: 'F8FAFC',
    isCompetitor: true,
    keywords: [
      'nike', 'nike türkiye', 'nike koşu ayakkabısı',
      'nike pegasus', 'nike pegasus 41',
      'nike vomero', 'nike vomero 17',
      'nike zoom fly', 'nike zoom fly 6',
      'nike react infinity', 'nike react infinity 4',
      'nike invincible', 'nike invincible 3',
      'nike winflo', 'nike air zoom structure',
      'nike free run', 'nike alphafly',
    ]
  },
  {
    name: 'Adidas',
    color: 'bg-zinc-50 border-zinc-200 text-zinc-700',
    xlsxColor: 'FAFAFA',
    isCompetitor: true,
    keywords: [
      'adidas', 'adidas türkiye', 'adidas koşu ayakkabısı',
      'adidas ultraboost', 'adidas ultraboost 5',
      'adidas adizero', 'adidas adizero boston',
      'adidas boston', 'adidas supernova',
      'adidas solarboost', 'adidas terrex',
      'adidas takumi sen',
    ]
  },
  {
    name: 'Puma',
    color: 'bg-yellow-50 border-yellow-200 text-yellow-700',
    xlsxColor: 'FEFCE8',
    isCompetitor: true,
    keywords: [
      'puma', 'puma türkiye', 'puma koşu ayakkabısı',
      'puma velocity nitro', 'puma velocity nitro 3',
      'puma deviate nitro', 'puma magnify nitro',
      'puma fast-r nitro', 'puma liberate nitro',
    ]
  },
  {
    name: 'New Balance',
    color: 'bg-gray-50 border-gray-200 text-gray-700',
    xlsxColor: 'F9FAFB',
    isCompetitor: true,
    keywords: [
      'new balance', 'new balance türkiye', 'new balance koşu ayakkabısı',
      'new balance 1080', 'new balance 880',
      'new balance more v4', 'new balance rebel',
      'new balance fresh foam', 'new balance fuelcell',
      'new balance sc trainer',
      'under armour', 'under armour türkiye', 'under armour hovr',
    ]
  },
  {
    name: 'Rakip Mağazalar',
    color: 'bg-rose-50 border-rose-200 text-rose-700',
    xlsxColor: 'FFF1F2',
    isCompetitor: true,
    keywords: [
      'intersport', 'intersport türkiye', 'decathlon', 'decathlon türkiye',
      'superstep', 'boyner spor', 'boyner', 'sportive',
      'sneaks up', 'vakkorama', 'beymen',
      'flower ayakkabı', 'flower shoes', 'laces',
      'koşu mağazası', 'spx spor', 'spx'
    ]
  },
  {
    name: 'Pazaryerleri',
    color: 'bg-violet-50 border-violet-200 text-violet-700',
    xlsxColor: 'F5F3FF',
    isCompetitor: true,
    keywords: [
      'koşu ayakkabısı trendyol', 'spor ayakkabı hepsiburada',
      'koşu ayakkabısı n11', 'amazon spor ayakkabı',
      'morhipo spor ayakkabı'
    ]
  },
];

// Filtered list: only brands, models, and competitor names (no generics)
const BRAND_MODEL_KEYWORDS = [
  // High5
  'high5',
  // On Running
  'on running', 'on cloud', 'on cloudmonster', 'on cloudstratus', 'on cloudflow',
  'on cloudsurfer', 'on cloudrunner', 'on cloudswift', 'on roger', 'on cloudventure',
  'on türkiye', 'on cloudmonster 2',
  // Hoka
  'hoka', 'hoka one one', 'hoka clifton', 'hoka bondi', 'hoka speedgoat',
  'hoka mach', 'hoka arahi', 'hoka challenger', 'hoka rincon', 'hoka gaviota',
  'hoka clifton 10',
  // Asics
  'asics', 'asics gel kayano', 'asics nimbus', 'asics novablast', 'asics gt 2000',
  'asics gel cumulus', 'asics gel resolution', 'asics magic speed', 'asics metaspeed',
  'asics türkiye', 'asics novablast 4',
  // Salomon
  'salomon', 'salomon speedcross', 'salomon sense ride', 'salomon x ultra',
  // Brooks
  'brooks', 'brooks ghost', 'brooks glycerin', 'brooks adrenaline', 'brooks hyperion',
  'brooks caldera', 'brooks cascadia', 'brooks levitate', 'brooks glycerin 21',
  // Saucony
  'saucony', 'saucony endorphin', 'saucony kinvara', 'saucony ride', 'saucony triumph',
  'saucony peregrine', 'saucony endorphin speed 4',
  // Skechers
  'skechers', 'skechers go run', 'skechers max cushioning',
  // Nike
  'nike', 'nike türkiye', 'nike pegasus', 'nike pegasus 41',
  'nike vomero', 'nike vomero 17', 'nike zoom fly', 'nike zoom fly 6',
  'nike react infinity', 'nike invincible', 'nike winflo', 'nike alphafly',
  // Adidas
  'adidas', 'adidas türkiye', 'adidas ultraboost', 'adidas ultraboost 5',
  'adidas adizero', 'adidas adizero boston', 'adidas boston',
  'adidas supernova', 'adidas solarboost', 'adidas terrex', 'adidas takumi sen',
  // Puma
  'puma', 'puma türkiye', 'puma velocity nitro', 'puma velocity nitro 3',
  'puma deviate nitro', 'puma magnify nitro', 'puma fast-r nitro', 'puma liberate nitro',
  // New Balance & Under Armour
  'new balance', 'new balance türkiye', 'new balance 1080', 'new balance 880',
  'new balance more v4', 'new balance rebel', 'new balance fresh foam', 'new balance fuelcell',
  'under armour', 'under armour türkiye', 'under armour hovr',
  // Rakip mağazalar
  'intersport', 'intersport türkiye', 'decathlon', 'decathlon türkiye',
  'superstep', 'boyner spor', 'boyner', 'sportive', 'sneaks up',
  'vakkorama', 'beymen', 'flower ayakkabı', 'flower shoes', 'laces',
  'spx spor', 'spx',
];

const ALL_KEYWORDS = KEYWORD_GROUPS.flatMap(g => g.keywords);

export default function High5KeywordResearch() {
  const [running, setRunning] = useState(false);
  const [results, setResults] = useState({});
  const [progress, setProgress] = useState({ done: 0, total: 0 });
  const [autoStarted, setAutoStarted] = useState(false);
  const [collapsedGroups, setCollapsedGroups] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: null, dir: 'desc' });
  const [brandsOnly, setBrandsOnly] = useState(true);
  const abortRef = useRef(false);

  const brandId = useMemo(() => {
    try { return localStorage.getItem('currentBrandId') || ''; } catch { return ''; }
  }, []);

  const fetchOne = useCallback(async (keyword) => {
    for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
      try {
        const res = await fetch('https://api.glowytics.com/api/search-volume/monthly', {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json', ...(brandId ? { 'X-Brand-ID': brandId } : {}) },
          body: JSON.stringify({ keyword, months: 0, languageConstant: '1037', geoTargetConstant: 'geoTargetConstants/2792' })
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          if (attempt < MAX_RETRIES && (res.status === 429 || res.status >= 500)) {
            await new Promise(r => setTimeout(r, 2000 * (attempt + 1)));
            continue;
          }
          return { keyword, monthly: [], error: err?.error || res.statusText };
        }
        const data = await res.json();
        if (data.success === false && attempt < MAX_RETRIES) {
          await new Promise(r => setTimeout(r, 2000 * (attempt + 1)));
          continue;
        }
        return {
          keyword,
          monthly: Array.isArray(data.monthly) ? data.monthly : [],
          competition: data.competition || null,
          competition_index: data.competition_index ?? null,
          top_of_page_bid_low: data.top_of_page_bid_low ?? null,
          top_of_page_bid_high: data.top_of_page_bid_high ?? null,
        };
      } catch (e) {
        if (attempt < MAX_RETRIES) {
          await new Promise(r => setTimeout(r, 2000 * (attempt + 1)));
          continue;
        }
        return { keyword, monthly: [], error: e.message };
      }
    }
  }, [brandId]);

  const activeKeywords = useMemo(() => brandsOnly ? BRAND_MODEL_KEYWORDS : ALL_KEYWORDS, [brandsOnly]);

  const runAll = useCallback(async () => {
    abortRef.current = false;
    setRunning(true);
    setResults({});
    setProgress({ done: 0, total: activeKeywords.length });

    let done = 0;
    let idx = 0;

    const runBatch = async () => {
      const batch = [];
      while (batch.length < CONCURRENCY && idx < activeKeywords.length) {
        if (abortRef.current) break;
        batch.push(fetchOne(activeKeywords[idx]));
        idx++;
      }
      const batchResults = await Promise.all(batch);
      const newEntries = {};
      for (const r of batchResults) {
        if (r) newEntries[r.keyword] = r;
      }
      done += batchResults.length;
      setResults(prev => ({ ...prev, ...newEntries }));
      setProgress({ done, total: activeKeywords.length });
    };

    while (idx < activeKeywords.length && !abortRef.current) {
      await runBatch();
      if (idx < activeKeywords.length && !abortRef.current) {
        await new Promise(r => setTimeout(r, BATCH_DELAY_MS));
      }
    }

    setRunning(false);
  }, [fetchOne, activeKeywords]);

  const stop = () => { abortRef.current = true; };

  const retryFailed = useCallback(async () => {
    const failedKeywords = activeKeywords.filter(kw => results[kw]?.error);
    if (failedKeywords.length === 0) return;
    abortRef.current = false;
    setRunning(true);
    setProgress({ done: 0, total: failedKeywords.length });
    let done = 0;
    let idx = 0;
    while (idx < failedKeywords.length && !abortRef.current) {
      const batch = [];
      while (batch.length < CONCURRENCY && idx < failedKeywords.length) {
        if (abortRef.current) break;
        batch.push(fetchOne(failedKeywords[idx]));
        idx++;
      }
      const batchResults = await Promise.all(batch);
      const newEntries = {};
      for (const r of batchResults) {
        if (r) newEntries[r.keyword] = r;
      }
      done += batchResults.length;
      setResults(prev => ({ ...prev, ...newEntries }));
      setProgress({ done, total: failedKeywords.length });
      if (idx < failedKeywords.length && !abortRef.current) {
        await new Promise(r => setTimeout(r, BATCH_DELAY_MS));
      }
    }
    setRunning(false);
  }, [fetchOne, activeKeywords, results]);

  // Auto-start on mount
  useEffect(() => {
    if (!autoStarted) {
      setAutoStarted(true);
      runAll();
    }
  }, [autoStarted, runAll]);

  const getAvg = (r) => {
    if (!r?.monthly || r.monthly.length === 0) return 0;
    const sum = r.monthly.reduce((s, m) => s + Number(m.monthly_searches || 0), 0);
    return Math.round(sum / r.monthly.length);
  };

  const getLast12Total = (r) => {
    if (!r?.monthly || r.monthly.length === 0) return 0;
    const sorted = [...r.monthly].sort((a, b) => (a.year * 100 + a.month) - (b.year * 100 + b.month));
    const last12 = sorted.slice(-12);
    return last12.reduce((s, m) => s + Number(m.monthly_searches || 0), 0);
  };

  const get3MonthChange = (r) => {
    if (!r?.monthly || r.monthly.length < 6) return null;
    const sorted = [...r.monthly].sort((a, b) => (a.year * 100 + a.month) - (b.year * 100 + b.month));
    const last3 = sorted.slice(-3);
    const prev3 = sorted.slice(-6, -3);
    const sumLast = last3.reduce((s, m) => s + Number(m.monthly_searches || 0), 0);
    const sumPrev = prev3.reduce((s, m) => s + Number(m.monthly_searches || 0), 0);
    if (sumPrev === 0) return null;
    return Math.round(((sumLast - sumPrev) / sumPrev) * 100);
  };

  const getMiniTrend = (r) => {
    if (!r?.monthly || r.monthly.length === 0) return [];
    const sorted = [...r.monthly].sort((a, b) => (a.year * 100 + a.month) - (b.year * 100 + b.month));
    return sorted.slice(-12).map(m => Number(m.monthly_searches || 0));
  };

  const formatPct = (val) => {
    if (val === null || val === undefined) return '-';
    const color = val > 0 ? 'text-emerald-600' : val < 0 ? 'text-red-600' : 'text-gray-500';
    return <span className={color}>{val > 0 ? '+' : ''}{val}%</span>;
  };

  const competitionColor = (comp) => {
    if (!comp) return '';
    if (comp === 'LOW') return 'bg-emerald-50 text-emerald-700 border-emerald-200';
    if (comp === 'MEDIUM') return 'bg-amber-50 text-amber-700 border-amber-200';
    if (comp === 'HIGH') return 'bg-red-50 text-red-700 border-red-200';
    return 'bg-gray-50 text-gray-600 border-gray-200';
  };

  const MiniSparkline = ({ data }) => {
    if (!data || data.length === 0) return <span className="text-gray-300">-</span>;
    const max = Math.max(...data, 1);
    const w = 80;
    const h = 24;
    const points = data.map((v, i) => `${(i / (data.length - 1)) * w},${h - (v / max) * h}`).join(' ');
    return (
      <svg width={w} height={h} className="inline-block">
        <polyline points={points} fill="none" stroke="#6366f1" strokeWidth="1.5" />
      </svg>
    );
  };

  const getGroupTotal = (group) => {
    return group.keywords.reduce((sum, kw) => {
      const r = results[kw];
      return sum + getAvg(r);
    }, 0);
  };

  const toggleGroup = (name) => {
    setCollapsedGroups(prev => ({ ...prev, [name]: !prev[name] }));
  };

  const handleSort = (key) => {
    setSortConfig(prev => prev.key === key ? { key, dir: prev.dir === 'desc' ? 'asc' : 'desc' } : { key, dir: 'desc' });
  };

  const sortKeywords = (keywords) => {
    if (!sortConfig.key || Object.keys(results).length === 0) return keywords;
    const getVal = (kw) => {
      const r = results[kw];
      if (!r) return -1;
      if (sortConfig.key === 'avg') return getAvg(r);
      if (sortConfig.key === 'last12') return getLast12Total(r);
      if (sortConfig.key === '3mo') return get3MonthChange(r) ?? -999;
      if (sortConfig.key === 'comp') {
        const m = { HIGH: 3, MEDIUM: 2, LOW: 1 };
        return m[r.competition] || 0;
      }
      return 0;
    };
    const sorted = [...keywords].sort((a, b) => {
      const va = getVal(a), vb = getVal(b);
      return sortConfig.dir === 'desc' ? vb - va : va - vb;
    });
    return sorted;
  };

  const SortIcon = ({ colKey }) => {
    if (sortConfig.key !== colKey) return <span className="text-gray-300 ml-1">↕</span>;
    return <span className="text-blue-600 ml-1">{sortConfig.dir === 'desc' ? '↓' : '↑'}</span>;
  };

  const exportExcel = () => {
    const wb = XLSXStyle.utils.book_new();

    const COLS = ['Category', 'Keyword', 'Avg Monthly', 'Last 12mo Total', '3mo Change %', 'Competition', 'CPC Low', 'CPC High'];
    const COL_WIDTHS = [{ wch: 22 }, { wch: 36 }, { wch: 14 }, { wch: 16 }, { wch: 14 }, { wch: 14 }, { wch: 10 }, { wch: 10 }];

    const headerStyle = {
      font: { bold: true, color: { rgb: 'FFFFFF' } },
      fill: { fgColor: { rgb: '4338CA' } },
      alignment: { horizontal: 'center', vertical: 'center' },
      border: { bottom: { style: 'thin', color: { rgb: 'C7D2FE' } } }
    };

    const makeCell = (value, bgColor, bold = false, alignRight = false) => ({
      v: value,
      t: typeof value === 'number' ? 'n' : 's',
      s: {
        fill: { fgColor: { rgb: bgColor } },
        font: { bold },
        alignment: { horizontal: alignRight ? 'right' : 'left', vertical: 'center' },
        border: { bottom: { style: 'hair', color: { rgb: 'E5E7EB' } } }
      }
    });

    // Groups: non-competitors first, competitors last
    const nonCompetitors = KEYWORD_GROUPS.filter(g => !g.isCompetitor);
    const competitors = KEYWORD_GROUPS.filter(g => g.isCompetitor);
    const orderedGroups = brandsOnly
      ? [...nonCompetitors, ...competitors]
      : [...nonCompetitors, ...competitors];

    // Build rows
    const wsData = [COLS.map(h => ({ v: h, t: 's', s: headerStyle }))];
    let rowNum = 1;
    const groupRowRanges = [];

    orderedGroups.forEach(group => {
      // For brandsOnly mode, only include keywords that are in BRAND_MODEL_KEYWORDS
      const kws = brandsOnly
        ? group.keywords.filter(kw => BRAND_MODEL_KEYWORDS.includes(kw))
        : group.keywords;
      if (kws.length === 0) return;

      const startRow = rowNum;
      kws.forEach(kw => {
        const r = results[kw];
        const bg = group.xlsxColor;
        wsData.push([
          makeCell(group.name, bg, false, false),
          makeCell(kw, bg, false, false),
          makeCell(r ? getAvg(r) : '', bg, false, true),
          makeCell(r ? getLast12Total(r) : '', bg, false, true),
          makeCell(r ? (get3MonthChange(r) ?? '') : '', bg, false, true),
          makeCell(r?.competition || '', bg, false, true),
          makeCell(r?.top_of_page_bid_low ?? '', bg, false, true),
          makeCell(r?.top_of_page_bid_high ?? '', bg, false, true),
        ]);
        rowNum++;
      });
      groupRowRanges.push({ name: group.name, start: startRow, end: rowNum - 1 });
    });

    const ws = XLSXStyle.utils.aoa_to_sheet(wsData);
    ws['!cols'] = COL_WIDTHS;
    ws['!rows'] = [{ hpt: 20 }]; // header row height

    XLSXStyle.utils.book_append_sheet(wb, ws, 'Keywords');
    XLSXStyle.writeFile(wb, `High5_Keywords_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  const pct = progress.total > 0 ? Math.round((progress.done / progress.total) * 100) : 0;
  const resultCount = Object.keys(results).length;
  const errorCount = Object.values(results).filter(r => r.error).length;

  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-1">
          <span className="px-2 py-0.5 rounded text-[10px] font-semibold bg-indigo-100 text-indigo-700 border border-indigo-200">REPORT</span>
          <h2 className="text-xl font-bold text-gray-900">High5 Boomsonar Keyword Research</h2>
        </div>
        <p className="text-sm text-gray-500">
          {activeKeywords.length} keyword{brandsOnly ? ' (brands, models & competitors only)' : ` across ${KEYWORD_GROUPS.length} groups`} &middot; Turkey / Turkish targeting &middot; Google Ads search volumes
        </p>
      </div>

      {/* Controls */}
      <div className="bg-white rounded-xl border shadow-sm p-4 mb-5 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="flex items-center bg-gray-100 rounded-lg p-0.5">
            <button
              onClick={() => { if (brandsOnly) { setBrandsOnly(false); setResults({}); setProgress({ done: 0, total: 0 }); } }}
              className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${!brandsOnly ? 'bg-white shadow text-gray-900' : 'text-gray-500 hover:text-gray-700'}`}
            >
              All ({ALL_KEYWORDS.length})
            </button>
            <button
              onClick={() => { if (!brandsOnly) { setBrandsOnly(true); setResults({}); setProgress({ done: 0, total: 0 }); } }}
              className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${brandsOnly ? 'bg-white shadow text-indigo-700' : 'text-gray-500 hover:text-gray-700'}`}
            >
              Brands & Models ({BRAND_MODEL_KEYWORDS.length})
            </button>
          </div>
          {running ? (
            <button onClick={stop} className="px-4 py-2 rounded-lg text-sm font-medium bg-red-600 text-white hover:bg-red-700">
              Stop
            </button>
          ) : (
            <button onClick={runAll} className="px-4 py-2 rounded-lg text-sm font-medium bg-blue-600 text-white hover:bg-blue-700">
              {resultCount > 0 ? 'Refresh All' : 'Fetch Volumes'}
            </button>
          )}
          {!running && errorCount > 0 && (
            <button onClick={retryFailed} className="px-4 py-2 rounded-lg text-sm font-medium bg-amber-500 text-white hover:bg-amber-600">
              Retry Failed ({errorCount})
            </button>
          )}
          {resultCount > 0 && (
            <button onClick={exportExcel} className="px-4 py-2 rounded-lg text-sm font-medium bg-emerald-600 text-white hover:bg-emerald-700">
              Export Excel
            </button>
          )}
        </div>
        <div className="text-sm text-gray-500">
          {resultCount > 0 && <span>{resultCount} / {activeKeywords.length} fetched</span>}
          {errorCount > 0 && <span className="ml-2 text-red-500">({errorCount} failed)</span>}
        </div>
      </div>

      {/* Progress */}
      {(running || progress.done > 0) && (
        <div className="bg-white rounded-xl border shadow-sm p-4 mb-5">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-700 font-medium">
              {progress.done} / {progress.total} ({pct}%)
            </span>
            {running && <span className="text-xs text-blue-600 animate-pulse">Fetching...</span>}
            {!running && progress.done > 0 && <span className="text-xs text-emerald-600">Done</span>}
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className="h-2 rounded-full transition-all duration-300"
              style={{ width: `${pct}%`, background: running ? '#3b82f6' : '#10b981' }}
            />
          </div>
        </div>
      )}

      {/* Summary Cards */}
      {resultCount > 0 && !brandsOnly && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
          {KEYWORD_GROUPS.map(g => (
            <div key={g.name} className={`rounded-xl border p-3 ${g.color}`}>
              <div className="text-[10px] font-semibold uppercase tracking-wide opacity-70">{g.name}</div>
              <div className="text-lg font-bold mt-1">{getGroupTotal(g).toLocaleString('tr-TR')}</div>
              <div className="text-[10px] opacity-60">{g.keywords.length} keyword &middot; avg/mo</div>
            </div>
          ))}
        </div>
      )}

      {/* Flat Table — Brands & Models Only */}
      {brandsOnly && (
        <div className="bg-white rounded-xl border shadow-sm mb-4 overflow-hidden">
          <div className="px-5 py-3 border-b bg-indigo-50">
            <span className="text-sm font-semibold text-indigo-800">
              Brands, Models & Competitors — {BRAND_MODEL_KEYWORDS.length} keywords
            </span>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full text-xs">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-3 py-2 text-left font-semibold text-gray-600 w-8">#</th>
                  <th className="px-3 py-2 text-left font-semibold text-gray-600">Keyword</th>
                  <th className="px-3 py-2 text-right font-semibold text-gray-600 cursor-pointer select-none hover:text-blue-600" onClick={() => handleSort('avg')}>
                    Avg Monthly<SortIcon colKey="avg" />
                  </th>
                  <th className="px-3 py-2 text-right font-semibold text-gray-600 cursor-pointer select-none hover:text-blue-600" onClick={() => handleSort('last12')}>
                    Last 12mo<SortIcon colKey="last12" />
                  </th>
                  <th className="px-3 py-2 text-right font-semibold text-gray-600 cursor-pointer select-none hover:text-blue-600" onClick={() => handleSort('3mo')}>
                    3mo Chg<SortIcon colKey="3mo" />
                  </th>
                  <th className="px-3 py-2 text-center font-semibold text-gray-600 cursor-pointer select-none hover:text-blue-600" onClick={() => handleSort('comp')}>
                    Competition<SortIcon colKey="comp" />
                  </th>
                  <th className="px-3 py-2 text-center font-semibold text-gray-600">Trend (12mo)</th>
                  <th className="px-3 py-2 text-center font-semibold text-gray-600">Status</th>
                </tr>
              </thead>
              <tbody>
                {sortKeywords(BRAND_MODEL_KEYWORDS).map((kw, i) => {
                  const r = results[kw];
                  return (
                    <tr key={kw} className="border-t hover:bg-gray-50">
                      <td className="px-3 py-1.5 text-gray-400">{i + 1}</td>
                      <td className="px-3 py-1.5 font-medium text-gray-900">{kw}</td>
                      <td className="px-3 py-1.5 text-right font-mono">
                        {r ? getAvg(r).toLocaleString('tr-TR') : <span className="text-gray-300">-</span>}
                      </td>
                      <td className="px-3 py-1.5 text-right font-mono">
                        {r ? getLast12Total(r).toLocaleString('tr-TR') : <span className="text-gray-300">-</span>}
                      </td>
                      <td className="px-3 py-1.5 text-right font-mono">
                        {r ? formatPct(get3MonthChange(r)) : <span className="text-gray-300">-</span>}
                      </td>
                      <td className="px-3 py-1.5 text-center">
                        {r?.competition ? (
                          <span className={`px-2 py-0.5 rounded text-[10px] border ${competitionColor(r.competition)}`}>
                            {r.competition}
                          </span>
                        ) : <span className="text-gray-300">-</span>}
                      </td>
                      <td className="px-3 py-1.5 text-center">
                        <MiniSparkline data={getMiniTrend(r)} />
                      </td>
                      <td className="px-3 py-1.5 text-center">
                        {!r ? (
                          running ? (
                            <span className="px-2 py-0.5 rounded text-[10px] bg-gray-50 text-gray-400 border border-gray-200">Waiting</span>
                          ) : (
                            <span className="px-2 py-0.5 rounded text-[10px] bg-gray-50 text-gray-400 border border-gray-200">-</span>
                          )
                        ) : r.error ? (
                          <span className="px-2 py-0.5 rounded text-[10px] bg-red-50 text-red-600 border border-red-200" title={r.error}>Error</span>
                        ) : !r.monthly || r.monthly.length === 0 ? (
                          <span className="px-2 py-0.5 rounded text-[10px] bg-amber-50 text-amber-600 border border-amber-200">No data</span>
                        ) : (
                          <span className="px-2 py-0.5 rounded text-[10px] bg-emerald-50 text-emerald-600 border border-emerald-200">OK</span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Grouped Tables */}
      {!brandsOnly && KEYWORD_GROUPS.map(group => (
        <div key={group.name} className="bg-white rounded-xl border shadow-sm mb-4 overflow-hidden">
          <button
            onClick={() => toggleGroup(group.name)}
            className="w-full px-5 py-3 flex items-center justify-between hover:bg-gray-50 transition-colors"
          >
            <div className="flex items-center gap-3">
              <span className={`px-2 py-0.5 rounded text-[10px] font-semibold border ${group.color}`}>
                {group.name}
              </span>
              <span className="text-sm text-gray-600">{group.keywords.length} keywords</span>
              {resultCount > 0 && (
                <span className="text-sm font-semibold text-gray-800">
                  Total: {getGroupTotal(group).toLocaleString('tr-TR')}/mo
                </span>
              )}
            </div>
            <svg className={`w-4 h-4 text-gray-400 transition-transform ${collapsedGroups[group.name] ? '' : 'rotate-180'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {!collapsedGroups[group.name] && (
            <div className="overflow-x-auto">
              <table className="min-w-full text-xs">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 py-2 text-left font-semibold text-gray-600 w-8">#</th>
                    <th className="px-3 py-2 text-left font-semibold text-gray-600">Keyword</th>
                    <th className="px-3 py-2 text-right font-semibold text-gray-600 cursor-pointer select-none hover:text-blue-600" onClick={() => handleSort('avg')}>
                      Avg Monthly<SortIcon colKey="avg" />
                    </th>
                    <th className="px-3 py-2 text-right font-semibold text-gray-600 cursor-pointer select-none hover:text-blue-600" onClick={() => handleSort('last12')}>
                      Last 12mo<SortIcon colKey="last12" />
                    </th>
                    <th className="px-3 py-2 text-right font-semibold text-gray-600 cursor-pointer select-none hover:text-blue-600" onClick={() => handleSort('3mo')}>
                      3mo Chg<SortIcon colKey="3mo" />
                    </th>
                    <th className="px-3 py-2 text-center font-semibold text-gray-600 cursor-pointer select-none hover:text-blue-600" onClick={() => handleSort('comp')}>
                      Competition<SortIcon colKey="comp" />
                    </th>
                    <th className="px-3 py-2 text-center font-semibold text-gray-600">Trend (12mo)</th>
                    <th className="px-3 py-2 text-center font-semibold text-gray-600">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {sortKeywords(group.keywords).map((kw, i) => {
                    const r = results[kw];
                    return (
                      <tr key={kw} className="border-t hover:bg-gray-50">
                        <td className="px-3 py-1.5 text-gray-400">{i + 1}</td>
                        <td className="px-3 py-1.5 font-medium text-gray-900">{kw}</td>
                        <td className="px-3 py-1.5 text-right font-mono">
                          {r ? getAvg(r).toLocaleString('tr-TR') : <span className="text-gray-300">-</span>}
                        </td>
                        <td className="px-3 py-1.5 text-right font-mono">
                          {r ? getLast12Total(r).toLocaleString('tr-TR') : <span className="text-gray-300">-</span>}
                        </td>
                        <td className="px-3 py-1.5 text-right font-mono">
                          {r ? formatPct(get3MonthChange(r)) : <span className="text-gray-300">-</span>}
                        </td>
                        <td className="px-3 py-1.5 text-center">
                          {r?.competition ? (
                            <span className={`px-2 py-0.5 rounded text-[10px] border ${competitionColor(r.competition)}`}>
                              {r.competition}
                            </span>
                          ) : <span className="text-gray-300">-</span>}
                        </td>
                        <td className="px-3 py-1.5 text-center">
                          <MiniSparkline data={getMiniTrend(r)} />
                        </td>
                        <td className="px-3 py-1.5 text-center">
                          {!r ? (
                            running ? (
                              <span className="px-2 py-0.5 rounded text-[10px] bg-gray-50 text-gray-400 border border-gray-200">Waiting</span>
                            ) : (
                              <span className="px-2 py-0.5 rounded text-[10px] bg-gray-50 text-gray-400 border border-gray-200">-</span>
                            )
                          ) : r.error ? (
                            <span className="px-2 py-0.5 rounded text-[10px] bg-red-50 text-red-600 border border-red-200" title={r.error}>Error</span>
                          ) : !r.monthly || r.monthly.length === 0 ? (
                            <span className="px-2 py-0.5 rounded text-[10px] bg-amber-50 text-amber-600 border border-amber-200">No data</span>
                          ) : (
                            <span className="px-2 py-0.5 rounded text-[10px] bg-emerald-50 text-emerald-600 border border-emerald-200">OK</span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
